import React from 'react';

import {
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input, InputProps } from '@/components/ui/input';

type IProps<AsProps = InputProps> = {
  title: string;
  helpText?: React.ReactNode;
  as?: React.ComponentType<AsProps> | string;
} & AsProps;

const InlineInput = React.forwardRef(
  <AsProps = InputProps,>(
    { title, as, helpText, ...props }: IProps<AsProps>,
    ref: React.Ref<any>,
  ) => {
    const As = (as || Input) as React.ComponentType<
      Omit<IProps<AsProps>, 'title' | 'as' | 'helpText'>
    >;

    return (
      <FormItem className="grid grid-cols-4 items-center gap-4">
        <FormLabel className="text-right">{title}</FormLabel>
        <div className="flex flex-col items-baseline col-span-3">
          <FormControl>
            <As {...props} ref={ref} />
          </FormControl>
          <FormMessage>{helpText}</FormMessage>
        </div>
      </FormItem>
    );
  },
) as <AsProps = InputProps>(
  // eslint-disable-next-line no-use-before-define
  p: IProps<AsProps> & { ref?: React.Ref<any> },
) => React.ReactElement;

export default InlineInput;
